export const ADD_LEAD_TO_FEED = 'ADD_LEAD_TO_FEED';

const addLeadToFeed = lead => (
  (dispatch) => {
    dispatch({
      type: ADD_LEAD_TO_FEED,
      lead,
    });
  }
);

export default addLeadToFeed;
